import { DatePicker, ConfigProvider } from 'antd'
import type { Dayjs } from 'dayjs'
import dayjs from 'dayjs'

const { RangePicker } = DatePicker

export interface DateRangeValue {
  from?: Date
  to?: Date
}

export interface DateRangePickerProps {
  value?: DateRangeValue
  onChange?: (range: DateRangeValue | undefined) => void
  placeholder?: [string, string]
  className?: string
  displayFormat?: string
  disabled?: boolean
}

export function DateRangePicker({
  value,
  onChange,
  className,
  disabled,
}: DateRangePickerProps) {
  const rangeValue: [Dayjs | null, Dayjs | null] = [
    value?.from ? dayjs(value.from) : null,
    value?.to ? dayjs(value.to) : null,
  ]

  function handleChange(dates: [Dayjs | null, Dayjs | null] | null) {
    if (!dates || (!dates[0] && !dates[1])) {
      onChange?.(undefined)
      return
    }
    onChange?.({
      from: dates[0]?.toDate(),
      to: dates[1]?.toDate(),
    })
  }

  return (
    <ConfigProvider
      theme={{
        token: {
          colorIcon: '#CE7A58',
          colorTextQuaternary: '#000000',
          colorTextPlaceholder: 'darkgray',
        },
        components: {
          DatePicker: {
            colorBgContainer: '#ffffff',
            colorBgElevated: '#ffffff',
          },
        },
      }}
    >
      <RangePicker
        value={rangeValue}
        onChange={handleChange}
        disabled={disabled}
        className={className}
        format="DD/MM/YYYY"
        separator="-"
        placeholder={['DD/MM/YYYY', 'DD/MM/YYYY']}
        style={{ borderRadius: '9999px' }}
        classNames={{
          popup: {
            root: 'max-md:[&_.ant-picker-panel:nth-child(2)]:hidden max-md:[&_.ant-picker-panel:first-child_.ant-picker-header-next-btn]:!visible max-md:[&_.ant-picker-panel:first-child_.ant-picker-header-super-next-btn]:!visible',
          },
        }}
      />
    </ConfigProvider>
  )
}